<template>
  <div class="non-verified-page">
    <FusionNonVerified />
  </div>
</template>

<style lang="scss" scoped>
.non-verified-page {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

:deep(.floating-card) {
  box-shadow:
    0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
</style>
